"use strict";
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';


// WEBPACK FOOTER //
// ./src/bootstrap-datepicker.js